import React, { FC, useEffect } from 'react';
import { ItemProps } from '../../types';



const LongText: FC<ItemProps> = (
    {
        formItem,
        formId
    }
) => {

    const [show, setShow] = React.useState<boolean>(false);
    const [count, setCount] = React.useState<number>(0);
    const groupRef =  React.useRef<HTMLDivElement>(null);

    const handleMoveChild = ()=> {

        const childElements = formItem?.itemOptions?.groupList?.map((child)=> `#form-${formId}-${child}`).join(' , ');
        const elements = document.querySelectorAll(childElements ?? '');
        setCount(elements.length);
        elements.forEach(element => {
            const parent = element.parentNode;
            if (parent) {
                parent.removeChild(element); // Explicitly remove the element from its current parent
            }
            groupRef?.current?.appendChild(element);
        });
    }



    useEffect(() => {
        handleMoveChild();
    }, []);

    const handleToggle = () => {
        setShow(!show);
    }


    return (
        <>

            <div className={` ${formItem.classNames?.container || ''}`}>
                {formItem.itemOptions?.description &&
                    <div className=" text-gray-500 text-sm font-normal border-b border-b-gray-300 pb-md">
                        {formItem.itemOptions?.description}
                    </div>
                }


                <div
                    className={`  ${groupRef.current?.offsetHeight} duration-500 overflow-hidden transition-all bg-gray-50 border border-gray-100 px-md rounded-md`}
                    style={{height: show ? `${(groupRef.current?.offsetHeight || 0) + 65 }px` : '44px'}}
                >

                    <div onClick={handleToggle} className={"rounded-md  h-[44px] justify-between hover:text-primary-600  transition-all  cursor-pointer bg-gray-50 flex items-center text-gray-400 text-text-md"}>

                        {show ?
                            <>
                                <span>Hide {formItem.placeholder || 'Items'} ({count})</span>
                                <span className={"font-icon-light"}>minus</span>
                            </>
                            :
                            <>
                                <span>Show  {formItem.placeholder || 'Items'} ({count})</span>
                                <span className={"font-icon-light"}>plus</span>
                            </>
                        }

                    </div>

                    <div ref={groupRef} className={`pt-md grid grid-cols-12 gap-md ${formItem.classNames?.content || ''} `}>

                    </div>


                </div>









            </div>

        </>
    );
};

export default LongText;
